// Lib
import { Action, handleActions } from 'redux-actions';
import { CSSProperties, ReactNode } from 'react';

// Actions
import { CloseDrawer, OpenDrawer, RemoveDrawerState } from '@actions/drawer';

interface DrawerState {
  display: boolean;
  children: ReactNode | null;
  style: CSSProperties | null;
  isTheme: boolean;
}

interface OpenDrawerPayload {
  children?: ReactNode;
  style?: CSSProperties;
  isTheme?: boolean;
}

type OpenDrawerAction = Action<OpenDrawerPayload>;

const initialState: DrawerState = {
  display: false,
  children: null,
  style: null,
  isTheme: false,
};

export default handleActions<DrawerState, OpenDrawerPayload | void>(
  {
    [OpenDrawer.toString()]: (
      _: DrawerState,
      { payload }: OpenDrawerAction,
    ): DrawerState => ({
      ...initialState,
      display: true,
      ...payload,
    }),
    [CloseDrawer.toString()]: (state: DrawerState): DrawerState => ({
      ...state,
      display: false,
    }),
    [RemoveDrawerState.toString()]: (): DrawerState => initialState,
  },
  initialState,
);
